import script from "./hf-logo.vue?vue&type=script&setup=true&lang=ts"
export * from "./hf-logo.vue?vue&type=script&setup=true&lang=ts"

const cssModules = {}
import style0 from "./hf-logo.vue?vue&type=style&index=0&id=5bfd9ba3&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__